import React from "react";
import DayHeader from "../../DayHeader";

interface WeekHeaderDeps {
  events: any[];
}

export default function renderWeekViewHeader(info: any, deps: WeekHeaderDeps) {
  return <DayHeader {...info} events={deps.events} />;
}
